<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import persistTableFilters from "@/mixins/persistTableFilters";
import {required,minValue} from "vuelidate/lib/validators";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import {FulfillingBouncingCircleSpinner} from "epic-spinners";
import vSelect from "vue-select";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import moment from 'moment';
import "vue-select/dist/vue-select.css";
// import moment from "moment";
// import Switches from "vue-switches";
import Datepicker from 'vuejs-datepicker';
// import DatePicker from "vue2-datepicker";
import {es} from 'vuejs-datepicker/dist/locale';
Vue.component("v-select", vSelect);
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import {mapState} from "vuex";
import {authComputed} from "@/state/helpers";
import 'bootstrap-icons/font/bootstrap-icons.css';

// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  mixins: [persistTableFilters],
  persistConfig: {
    key: "taller_filtros",
    fields: ["search", "perPage", "searchLabel", "filterLabel",
             "fecha_inicio", "fecha_fin", "rangode_fecha", "tipo_label"],
  },
  page: {
    title: "Taller",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    Layout,
    datepicker: Datepicker,
    PageHeader,
    Loader,
    Vuetable,
    "masked-input": MaskedInput,
    VuetablePagination,
    // Switches,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    // DatePicker,
  },
  data() {
    return {
      idCaja : 0,
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      es :es,
      disabledDates: {
          to: '',
      },
      swAnular: false,
      tipo_label: {nombre: "Pendientes de pago", value: 0},
      tipo_array: [
        {nombre: "Pendientes de pago", value: 0},
        {nombre: "Pagados", value: 1},
      ],
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: {"x-token": this.$store.state.authfack.user.token},
      },
      metododeBusqueda: false,
      fecha_inicio: "",
      rangode_fecha: "",
      fecha_fin: "",
      bandera_fecha: false,
      repit: true,
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "ordenes/get?tienda="+this.$store.state.authfack.user.tienda,
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      formVenta: {
        total: "",
        cliente: "",
        nombre: "",
        descripcion: "",
        tiendaid: "",
        state: true,
        id: 0,
      },
      formPro: {
        total: "",
      },
      tiendasData: [],
      updating: false,
      estadotabla: true,
      title: "Taller",
      itemst: [
        {
          text: "Taller",
          href: "/",
        },
        {
          text: "Listado",
          active: true,
        },
      ],
      fields: [
        {
          name: "no_servicio",
          title: "Servicio",
          sortField: "no_servicio",
          // width: "5%",
        },
        {
          name: "empleado",
          title: "Empleado",
          sortField: "empleado",
          // width: "10%",
        },
        // {
        //   name: "cliente_rapido",
        //   title: "Cliente Rapido",
        //   sortField: "cliente_rapido",
        //   // width: "10%",
        // },
        {
          name: "cliente",
          title: "Cliente",
          sortField: "cliente",
          // width: "15%",
        },
        {
          name: "fechac",
          title: "Fecha Ingreso",
          sortField: "fechac",
          // width: "15%",
        },
        {
          name: "fechach",
          title: "Fecha Entrega",
          sortField: "fechach",
          // width: "15%",
        },
        // {
        //   name: "fecha",
        //   title: "Fecha Vencimiento",
        //   sortField: "fecha",
        //   width: "15%",
        // },
        {
          name: "total",
          title: "Total",
          sortField: "total",
          // width: "15%",
        },
        {
          name: "adelanto",
          title: "Adelanto",
          sortField: "Adelanto",
          // width: "15%",
        },

        {
          name: "estado_pago",
          title: "Crédito",
          titleClass: "",
          dataClass: "text-muted",
          // width: "10%",
        },
        {
          name: "estado_diagnostico_a",
          title: "Diagnostico",
          titleClass: "",
          dataClass: "text-muted",
          // width: "10%",
        },

        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          // width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          // width: "10%",
        },
      ],
      searchType: [
        {nombre: "Cliente", value: "cliente"},
        {nombre: "No. Servicio", value: "no_servicio"},
        {nombre: "Empleado", value: "empleado"},
        {nombre: "Fecha entrada", value: "fecha"},
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      modalAdelantos : false,
      loadingtable: false,
      sortBy: "nombre_orden",
      sortDesc: false,
      searchLabel: {nombre: "Cliente", value: "cliente"},
      filterLabel: {nombre: "Cliente", value: "cliente"},
      showModalL: false, //Loading
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
      items: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 4,
      from: 0,
      to: 0,
      total: 0,
      adelanto: 0,
      arrayAdelantos:[],
      totalAdelantoP:0,
      lastPage: 0,
      validateArqueo : false,
      formCredito: {
        color: false,
        asignado: false,
        fechaInicio: new Date(),
        intervalo: 7,
        collapse1: false,
        pagos: [],
        precioNuevo: 0,
        adelanto: "0",
        cantidadPagos: 0,
      },
      cantidad_efectivo: "",
      transferencia: [
        {
          cantidad_transferencia: "",
          transaccion_transferencia: "",
          button: true,
        },
      ],
      deposito: [
        {
          cantidad_deposito: "",
          transaccion_deposito: "",
          button: true,
        },
      ],
      cheque: [
        {
          cantidad_cheque: "",
          transaccion_cheque: "",
          button: true,
        },
      ],
      tarjeta: [
        {
          cantidad_tarjeta: "",
          transaccion_tarjeta: "",
          button: true,
        },
      ],
      checkMoney: {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      },
      checkSelect: {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      },
      montoFinal: {
        cantidad: 0,
        metodo: "",
        transaccion: "",
      },
      montos: {
        monto_efectivo: "",
        monto_transferencia: [],
        monto_deposito: [],
        monto_cheque: [],
        monto_tarjeta: [],
      },
    };
  },
  validations: {
    formVenta: {
      nombre: {
        required,
        async isUnique(value) {
          if (value === "") return true;
          let response = await axios
              .get(
                  this.apiUrl +
                  "departamentos/nombre_repetido?nombre=" +
                  value +
                  "&id=" +
                  this.formVenta.id +
                  "&tienda=" +
                  this.formVenta.tiendaid.id,
                  {
                    headers: {"x-token": this.userT.token},
                  }
              )
              .catch(console.log);
          this.repit = response.data.msg;
          // console.log(response.data.msg);
          return response.data.msg;
        },
      },
      descripcion: {required},
      tiendaid: {required},
    },
    adelanto: {required},
    formPro: {
      total: { required },
    },
    cantidad_efectivo: {
      required,
      // minValue: minValue(1),
    },
    transferencia: {
      required,
      $each: {
        cantidad_transferencia: {
          required,
          // minValue: minValue(1),
        },
        transaccion_transferencia: {
          required,
        },
      },
    },
    deposito: {
      required,
      $each: {
        cantidad_deposito: {
          required,
          // minValue: minValue(1),
        },
        transaccion_deposito: {
          required,
        },
      },
    },
    cheque: {
      required,
      $each: {
        cantidad_cheque: {
          required,
          // minValue: minValue(1),
        },
        transaccion_cheque: {
          required,
        },
      },
    },
    tarjeta: {
      required,
      $each: {
        cantidad_tarjeta: {
          required,
          // minValue: minValue(1),
        },
        transaccion_tarjeta: {
          required,
        },
      },
    },
    montoFinal: {
      cantidad: {
        minValue: minValue(1),
      },
    },
  },
  mounted() {
    // console.log('hola')
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: {"x-token": usuario.token},
      })
          .then((res) => {
            if (res.data.success) {
              // this.$router.push("/");
            }
          })
          .catch(() => {
            this.logout();
            location.reload();
          });
    }
    this.validarCaja();
    this.iniciarTablaConFiltros();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    validarModalCredito() {
      if (this.formCredito.collapse1 == true) {
        const { pagos, intervalo, precioNuevo, adelanto, cantidadPagos } =
          this.formCredito;
        if (
          intervalo > 0 &&
          precioNuevo > 0 &&
          adelanto >= 0 &&
          cantidadPagos > 0 &&
          pagos.length > 0
        ) {
          if (this.montoFinal.cantidad > 0) {
            if (
              this.checkMoney.efectivo ||
              this.checkMoney.transferencia ||
              this.checkMoney.deposito ||
              this.checkMoney.cheque ||
              this.checkMoney.tarjeta
            ) {
              this.bandera = false;
              if (this.checkMoney.efectivo) {
                if (this.converMaskToNumberxd(this.cantidad_efectivo) == "") {
                  this.bandera = true;
                  Vue.toasted.error("Agregue monto en efectivo", this.options);
                } else {
                  this.montos.monto_efectivo = parseFloat(
                    this.converMaskToNumberxd(this.cantidad_efectivo)
                  );
                }
              }
              if (this.checkMoney.transferencia) {
                let temp = 0;
                for (let i = 0; i < this.transferencia.length; i++) {
                  if (
                    this.transferencia[i].cantidad_transferencia == "" ||
                    this.transferencia[i].transaccion_transferencia == ""
                  ) {
                    temp++;
                  }
                }
                if (temp > 0) {
                  this.bandera = true;
                  Vue.toasted.error(
                    "Complete campos de transferencia",
                    this.options
                  );
                } else {
                  this.montos.monto_transferencia = [];
                  for (let i = 0; i < this.transferencia.length; i++) {
                    this.montos.monto_transferencia.push({
                      monto_transferencia: parseFloat(
                        this.converMaskToNumberxd(
                          this.transferencia[i].cantidad_transferencia
                        )
                      ),
                      transaccion_transferencia:
                        this.transferencia[i].transaccion_transferencia,
                    });
                  }
                }
              }
              if (this.checkMoney.deposito) {
                let temp = 0;
                for (let i = 0; i < this.deposito.length; i++) {
                  if (
                    this.deposito[i].cantidad_deposito == "" ||
                    this.deposito[i].transaccion_deposito == ""
                  ) {
                    temp++;
                  }
                }
                if (temp > 0) {
                  this.bandera = true;
                  Vue.toasted.error(
                    "Complete campos de deposito",
                    this.options
                  );
                } else {
                  this.montos.monto_deposito = [];
                  for (let i = 0; i < this.deposito.length; i++) {
                    this.montos.monto_deposito.push({
                      monto_deposito: parseFloat(
                        this.converMaskToNumberxd(
                          this.deposito[i].cantidad_deposito
                        )
                      ),
                      transaccion_deposito:
                        this.deposito[i].transaccion_deposito,
                    });
                  }
                }
              }
              if (this.checkMoney.cheque) {
                let temp = 0;
                for (let i = 0; i < this.cheque.length; i++) {
                  if (
                    this.cheque[i].cantidad_cheque == "" ||
                    this.cheque[i].transaccion_cheque == ""
                  ) {
                    temp++;
                  }
                }
                if (temp > 0) {
                  this.bandera = true;
                  Vue.toasted.error("Complete campos de cheque", this.options);
                } else {
                  this.montos.monto_cheque = [];
                  for (let i = 0; i < this.cheque.length; i++) {
                    this.montos.monto_cheque.push({
                      monto_cheque: parseFloat(
                        this.converMaskToNumberxd(
                          this.cheque[i].cantidad_cheque
                        )
                      ),
                      transaccion_cheque: this.cheque[i].transaccion_cheque,
                    });
                  }
                }
              }
              if (this.checkMoney.tarjeta) {
                let temp = 0;
                for (let i = 0; i < this.tarjeta.length; i++) {
                  if (
                    this.tarjeta[i].cantidad_tarjeta == "" ||
                    this.tarjeta[i].transaccion_tarjeta == ""
                  ) {
                    temp++;
                  }
                }
                if (temp > 0) {
                  this.bandera = true;
                  Vue.toasted.error("Complete campos de tarjeta", this.options);
                } else {
                  this.montos.monto_tarjeta = [];
                  for (let i = 0; i < this.tarjeta.length; i++) {
                    this.montos.monto_tarjeta.push({
                      monto_tarjeta: parseFloat(
                        this.converMaskToNumberxd(
                          this.tarjeta[i].cantidad_tarjeta
                        )
                      ),
                      transaccion_tarjeta: this.tarjeta[i].transaccion_tarjeta,
                    });
                  }
                }
              }
              if (this.bandera == false) {
                if (
                  this.montoFinal.cantidad ==
                  parseFloat(
                    this.converMaskToNumberxd(this.formCredito.adelanto)
                  )
                ) {
                  // this.showModalL = true;
                  this.asignarCredito();
                } else {
                  Vue.toasted.error(
                    `La cantidad actual no coincide con el monto a pagar. La diferencia es de <strong>${this.formatQuetzales(
                      this.montoFinal.cantidad -
                        parseFloat(
                          this.converMaskToNumberxd(this.formCredito.adelanto)
                        )
                    )}</strong>`,
                    this.options
                  );
                }
              } else {
                Vue.toasted.error(
                  "Ingrese cantidades en los métodos de pago",
                  this.options
                );
              }
            } else {
              Vue.toasted.error(
                "Seleccione al menos un método de pago",
                this.options
              );
            }
          } else {
            Vue.toasted.error("Agregue métodos de pago", this.options);
          }
        } else {
          Vue.toasted.error("Complete los campos de crédito", this.options);
        }
      } else {
        const { pagos, intervalo, precioNuevo, adelanto, cantidadPagos } =
          this.formCredito;
        if (
          intervalo > 0 &&
          precioNuevo > 0 &&
          adelanto >= 0 &&
          cantidadPagos > 0 &&
          pagos.length > 0
        ) {
          this.asignarCredito();
        } else {
          Vue.toasted.error("Complete los campos de crédito", this.options);
        }
      }
    },
    resetCredito() {
      // Reset credito
      // console.log( this.formPro.total);
      // this.formCredito.precioNuevo = this.formPro.total;
      this.formCredito.color = false;
      this.formCredito.asignado = false;
      this.formCredito.intervalo = 7;
      this.formCredito.collapse1 = false;
      this.formCredito.pagos = [];
      this.formCredito.adelanto = "0";
      this.formCredito.cantidadPagos = 0;

      //  Reset metodos de pago
      this.bandera = false;
      this.cantidad_efectivo = "";
      this.transferencia = [
        {
          cantidad_transferencia: "",
          transaccion_transferencia: "",
          button: true,
        },
      ];
      this.deposito = [
        {
          cantidad_deposito: "",
          transaccion_deposito: "",
          button: true,
        },
      ];
      this.cheque = [
        {
          cantidad_cheque: "",
          transaccion_cheque: "",
          button: true,
        },
      ];
      this.tarjeta = [
        {
          cantidad_tarjeta: "",
          transaccion_tarjeta: "",
          button: true,
        },
      ];
      this.checkMoney = {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      };
      this.checkSelect = {
        efectivo: false,
        deposito: false,
        cheque: false,
        transferencia: false,
        tarjeta: false,
      };
      this.montoFinal = {
        cantidad: 0,
        metodo: "",
        transaccion: "",
      };
      this.montos = {
        monto_efectivo: "",
        monto_transferencia: [],
        monto_deposito: [],
        monto_cheque: [],
        monto_tarjeta: [],
      };
    },
    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
          number.charAt(i) === "Q" ||
          number.charAt(i) === "€" ||
          number.charAt(i) === "$" ||
          number.charAt(i) === "%" ||
          number.charAt(i) === "," ||
          number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    activarBuscadorFechas(search){
      // console.log(search);
      this.bandera_fecha = (search.value == "fecha") ? true : false;
      // console.log(this.bandera_fecha)
    },
    updateDisableDates(){
      let me = this;
      if(new Date(me.customFormatter(me.fecha_inicio)).getTime() > new Date(me.customFormatter(me.fecha_fin))){
          me.$refs.myDatepicker.clearDate();
          me.fecha_fin = '';
      }
      me.disabledDates.to = new Date(me.fecha_inicio);
    },
    // customFormatter(date) {
    //   return moment(date).format('YYYY-MM-DD');
    // },
    limpiarfiltro(){
        let me = this;
        me.fecha_inicio = "";
        me.fecha_fin = "";
    },
    inicioRapido() {
      let me = this;
      // console.log(me.userT);
      axios
          .post(
              process.env.VUE_APP_URL + "caja/store",
              {
                inicio_caja: 0,
                observacion: "Inicio de caja rápido " + this.showHour(new Date()),
                usuario: me.userT.id,
                tienda: me.userT.tienda
              },
              {
                headers: {"x-token": me.userT.token},
              }
          )
          .then(() => {
            Vue.toasted.success("Inicio de caja rápido realizado", me.options);
            me.validarCaja();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
    },
    validarCaja() {
      let me = this;
      axios
          .get(
              process.env.VUE_APP_URL +
              "caja/get_validate?" +
              "&usuario=" +
              this.userT.id + "&tienda=" + this.$store.state.authfack.user.tienda,
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then((response) => {
          // console.log(response);
          this.idCaja =  response.data.validate == "null" ||
                response.data.validate == "" ||
                response.data.validate == null
                  ? 0
                  :  response.data.validate.id;
          // console.log(this.idCaja);

          this.validateArqueo =
                response.data.validate == "null" ||
                response.data.validate == "" ||
                response.data.validate == null
                  ? false
                  : true;
            if (response.data.validate) {
          
          
              me.$bvModal.hide("modalValidacion");
              return;
            }
            me.$bvModal.show("modalValidacion");
          });
    },
    anularVenta() {
      console.log(this.formVenta.id);
      axios
          .put(
              process.env.VUE_APP_URL + "ordenes/desactivate",
              {
                id: this.formVenta.id,
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then(() => {
            this.$refs.vuetable.refresh();
            this.$refs["modalAnular"].hide();
          
            Vue.toasted.error(
                "Servicio anulada",
                this.options
            );
       
            this.swAnular = false;
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
      // .finally(() => {

      // });
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      
      return date == 'null' ? '' : date =='' ? '' : date == null ? '': moment(date).locale("es").format("MMM Do YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    validarFecha(fecha) {
      let hoy = moment(new Date());
      let vec = moment(fecha);
      if (hoy > vec) {
        return true;
      } else {
        return false;
      }
    },
    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
        // console.log(paginationData)
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
      this.persistFiltros();
      // console.log(this.items)
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },
    async changeTypeDates(fecha_inicio, fecha_fin) {
      // await this.separarfechas();
      this.fecha_inicio = fecha_inicio;
      this.fecha_fin = fecha_fin;
      this.$refs.vuetable.refresh();
    },
    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.fecha_inicio = type.value == "fecha" ? this.fecha_inicio : "";
      this.fecha_fin = type.value == "fecha" ?     this.fecha_fin : "";
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    changeTipoVenta(type) {
      this.tipo_label = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
          ? {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0]
                ? sortOrder[0].sortField
                : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            estado: this.tipo_label.value,
          }
          : {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0]
                ? sortOrder[0].sortField
                : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            estado: this.tipo_label.value,
          };
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formVenta.id = 0;
      this.formVenta.descripcion = "";
      this.formVenta.nombre = "";
      this.formVenta.tiendaid = null;
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalN = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },
    sumarPagosTaller(pagos){  
      // console.log(pagos)
        return pagos.reduce((total, item) => {
          let monto = parseFloat(item.adelanto); // Convierte el valor a número
          if (!isNaN(monto)) { // Verifica si es un número válido
              return total + monto;
          }
          return total;
      }, 0);
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    async onActionClicked(action, data) {
      //await this.GenerateReport();
      if (action == "aprobar-item") {
        this.formVenta;
        this.formVenta.id = data.id;
        await this. viewAdelanto();
        this.formVenta.descripcion =
            "Anulación de venta el día " + this.showHour(new Date()) + " por ";
        this.formVenta.total =
            data.estado_cuenta == true
                ? parseFloat(data.pago_cuenta) + parseFloat(data.total)
                : data.total;
        this.formVenta.cliente = data.vehiculo.cliente.persona.nombre_persona;
        this.formVenta.nombre = data.no_servicio;
        
      }
      if (action == "aprobar-contado") {
        this.formVenta;
        this.formVenta.id = data.id;
        await this. viewAdelanto();
        this.formVenta.descripcion =
            "Pagar servicio al contado";
            this.formPro.total = data.total;
        this.formVenta.cliente = data.vehiculo.cliente.persona.nombre_persona;
        this.formVenta.nombre = data.no_servicio;
       
        // console.log(  this.formVenta.total)
      }
      if (action == "aprobar-adelanto") {
        this.formVenta.id = data.id;
        this. viewAdelanto();
        // console.log(  this.formVenta.total)
      }
      if (action == "adelantos") {
        this.formVenta.id = data.id;
        this. viewAdelanto();
        this.modalAdelantos = true;
        // console.log(  this.formVenta.total)
      }
      if (action == "abonar-item") {
        // console.log(data);
        this.formVenta.id = data.id;
         this.resetCredito();
        // this.totalModal = data.saldo_credito_v;
        // this.formCre.nombre = data.no_ducumento_v;
        // this.formCre.id = data.id;
    
      
        await this. viewAdelanto();
        this.showModalA = true;
        // console.log(data);
        this.formPro.total = parseFloat(data.total) - parseFloat(this.totalAdelantoP);
        this.formCredito.precioNuevo =  this.formPro.total;
        // console.log( this.formPro.total);
      
      }
    },
    checkboxChange(action) {
      this.$v.$reset();
      if (action == "efectivo" && !this.checkMoney.efectivo) {
        this.cantidad_efectivo = "";
        this.sumarCantidades();
      }

      if (action == "transferencia" && !this.checkMoney.transferencia) {
        this.transferencia = [
          {
            cantidad_transferencia: "",
            transaccion_transferencia: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
      if (action == "deposito" && !this.checkMoney.deposito) {
        this.deposito = [
          {
            cantidad_deposito: "",
            transaccion_deposito: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }

      if (action == "cheque" && !this.checkMoney.cheque) {
        this.cheque = [
          {
            cantidad_cheque: "",
            transaccion_cheque: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
      if (action == "tarjeta" && !this.checkMoney.tarjeta) {
        this.cheque = [
          {
            cantidad_tarjeta: "",
            transaccion_tarjeta: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
    },
    sumarCantidades() {
      let sum = 0;
      let sum2 = 0;
      let sum3 = 0;
      let sum4 = 0;
      let sum5 = 0;

      if (this.checkMoney.efectivo) {
        sum =
          parseFloat(this.converMaskToNumberxd(this.cantidad_efectivo)) > 0
            ? parseFloat(this.converMaskToNumberxd(this.cantidad_efectivo))
            : 0;
        // this.validarCantidades.efectivo = sum;
      }

      if (this.checkMoney.transferencia) {
        for (let i = 0; i < this.transferencia.length; i++) {
          sum2 =
            sum2 +
            (parseFloat(
              this.converMaskToNumberxd(
                this.transferencia[i].cantidad_transferencia
              )
            ) > 0
              ? parseFloat(
                  this.converMaskToNumberxd(
                    this.transferencia[i].cantidad_transferencia
                  )
                )
              : 0);
        }
      }

      if (this.checkMoney.deposito) {
        for (let i = 0; i < this.deposito.length; i++) {
          sum3 =
            sum3 +
            (parseFloat(
              this.converMaskToNumberxd(this.deposito[i].cantidad_deposito)
            ) > 0
              ? parseFloat(
                  this.converMaskToNumberxd(this.deposito[i].cantidad_deposito)
                )
              : 0);
        }
      }

      if (this.checkMoney.cheque) {
        for (let i = 0; i < this.cheque.length; i++) {
          sum4 =
            sum4 +
            (parseFloat(
              this.converMaskToNumberxd(this.cheque[i].cantidad_cheque)
            ) > 0
              ? parseFloat(
                  this.converMaskToNumberxd(this.cheque[i].cantidad_cheque)
                )
              : 0);
        }
      }

      if (this.checkMoney.tarjeta) {
        for (let i = 0; i < this.tarjeta.length; i++) {
          sum5 =
            sum5 +
            (parseFloat(
              this.converMaskToNumberxd(this.tarjeta[i].cantidad_tarjeta)
            ) > 0
              ? parseFloat(
                  this.converMaskToNumberxd(this.tarjeta[i].cantidad_tarjeta)
                )
              : 0);
        }
      }

      this.montoFinal.cantidad = sum + sum2 + sum3 + sum4 + sum5;

      // if (accion == 1) {
      //   this.montoFinal.cantidad = parseFloat(
      //     this.converMaskToNumberxd(cantidad)
      //   );
      // } else {
      //   this.montoFinal.transaccion = cantidad;
      // }
    },
    asignarCredito() {
      this.formCredito.color = true;
      this.formCredito.asignado = true;
      this.savePagoCredito();
    },
    formatQuetzales(amount) {
      let num = parseFloat(amount),
        formatted;
      formatted = num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return (amount = "Q " + formatted);
    },
    calcularCredito() {
      this.formCredito.pagos = [];
      let pagosTemporal = [];
      let {
        intervalo,
        precioNuevo,
        // adelanto,
        fechaInicio,
        // collapse1,
        pagos,
        cantidadPagos,
      } = this.formCredito;

      const cantidad = precioNuevo / cantidadPagos;
      // this.formCredito.pagos = [];
      for (let i = 0; i < cantidadPagos; i++) {
        if (i == 0) {
          pagosTemporal.push({
            fecha1: fechaInicio,
            fecha2: moment(fechaInicio).add(intervalo, "days"),
          });
        } else {
          pagosTemporal.push({
            fecha1: pagosTemporal[i - 1].fecha2,
            fecha2: moment(pagosTemporal[i - 1].fecha2).add(intervalo, "days"),
          });
        }
        pagos.push({
          monto_pago: cantidad,
          fecha_pago: this.customFormatter(pagosTemporal[i].fecha1),
        });
      }
    },
    validarCredito() {
      const { intervalo, precioNuevo, adelanto, cantidadPagos } =
        this.formCredito;
//       console.log(intervalo,
// precioNuevo,
// parseFloat(adelanto),
// parseInt(cantidadPagos));
      if (
        intervalo > 0 &&
        precioNuevo > 0 &&
        parseFloat(adelanto) >= 0 &&
        parseInt(cantidadPagos) > 0
      ) {
        this.calcularCredito();
      } else {
        Vue.toasted.error("Complete los campos de crédito", this.options);
      }
    },
    asignarAdelanto() {
      this.formCredito.pagos = [];
      this.formCredito.fechaInicio = new Date();
      this.formCredito.intervalo = 7;
      this.formCredito.cantidadPagos = 0;

      // let adelantoTemp = parseFloat(this.converMaskToNumberxd(this.formCredito.adelanto))

      if (this.formCredito.adelanto > 0) {
        // console.log("a");
        this.formCredito.collapse1 = true;
        this.formCredito.precioNuevo =
          this.formPro.total - this.formCredito.adelanto;
      } else {
        this.formCredito.precioNuevo = this.formPro.total;
        this.formCredito.collapse1 = false;
      }
    },
    async viewAdelanto(){
      // let me = this;
      const res = await axios
          .get(
              process.env.VUE_APP_URL +
              "ordenes/get/view_adelanto?" +
              "&id=" +
              this.formVenta.id ,
              {
                headers: {"x-token": this.userT.token},
              }
          );
          this.arrayAdelantos= res.data.respuesta
          this.totalAdelantoP = this.arrayAdelantos.reduce((total, respuesta) => {
            return parseFloat(total) + parseFloat(respuesta.adelanto);
          }, 0);
        
    },

    async GenerateReport(){
      // let me = this;
      try {
    const urlas = process.env.VUE_APP_URL + 'reports/product_by_service';
    
    const response = await axios({
      url: urlas, 
      method: 'GET',
      responseType: 'blob', // Importante para recibir el PDF como un Blob binario
    });

    // Crear un enlace temporal para forzar la descarga
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'reporte_ganancias.pdf'); // Nombre del archivo de descarga
    document.body.appendChild(link);
    link.click(); // Forzar el clic para descargar

    // Eliminar el enlace temporal
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error al descargar el PDF', error);
  }
        
    },
    
    savePagoCredito(estado = true) {
      const { total } =
        this.formPro;

        // console.log(this.formCredito.asignado);
        axios
          .post(
            process.env.VUE_APP_URL + "ordenes/pago_servicio",
            {
              id : this.formVenta.id,
              caja : this.idCaja,
              usuario: this.userT.id,
              tienda: this.userT.tienda,
              metodo : estado ,
              fecha_pago :this.formCredito.pagos.length <=0 ? this.formCredito.fechaInicio: this.formCredito.pagos[this.formCredito.pagos.length - 1].fecha_pago,
              total,
              
              // Creditos
              saldo: this.formCredito.precioNuevo,
              cantidad_pagos: this.formCredito.cantidadPagos,
              montos: this.montos,
              abono: parseFloat(
                this.converMaskToNumberxd(this.formCredito.adelanto)
              ),
              fecha_inicial: this.formCredito.fechaInicio,
              data_pagos: this.formCredito.pagos,
            },
            {
              headers: { "x-token": this.userT.token },
            }
          )
          .then(() => {
            this.$refs.vuetable.refresh();
            Vue.toasted.success("Pago realizado con éxito", this.optionsFast);
            this.limpiarTodo();

              
            this.$refs["modalCredito"].hide();
            
            this.$refs["modalContado"].hide();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
    
    },
    limpiarTodo() {
      this.limpiarVariables();
      this.resetCredito();
      this.formPro;
      this.formPro = {
        fecha_compra: new Date(),
        tiendaid: "",
        observaciones: "",
        tienda: "",
        cliente: null,
        total: "",
        total_servicios: "",
        total_productos: "",
        state: true,
        id: 0,
      };
      this.porcentaje = "";
      this.indexPorcentaje = "";
      this.precioOriginal = "";
      this.precioDescuento = "";
      this.arrayProductos = [];
      this.producto = "";
      this.arrayServicios = [];
      this.servicio = "";
      this.arrayDetalle = [];
      this.arrayDetalleServicio = [];
      this.search = "";
      this.search2 = "";
    },
    saveAdelanto(){
      this.$v.$touch();
      if (this.adelanto  <=0 || this.adelanto == "" || this.adelanto == undefined) {
        return;
      }

      axios
          .post(
            process.env.VUE_APP_URL + "ordenes/store/adelanto",
            {
              id : this.formVenta.id,
              usuario: this.userT.id,
              adelanto :this.adelanto
            },
            {
              headers: { "x-token": this.userT.token },
            }
          )
          .then(() => {
            this.$refs.vuetable.refresh();
            Vue.toasted.success("Pago realizado con éxito", this.optionsFast);
            this.limpiarTodo();

              
            this.$refs["modalAdelanto"].hide();
            
            this.$refs["modalAdelanto"].hide();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
    }
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="itemst"/>

    <div class="row">
      <div class="col-12">
        <!-- Modal validacion caja -->
        <b-modal
            centered
            id="modalValidacion"
            title-class="text-black font-18"
            body-class="p-3"
            no-close-on-backdrop
            hide-footer
            hide-header
        >
          <h2>No se ha iniciado la caja</h2>
          <br/>
          <div class="row">
            <div class="col d-grid gap-2">
              <b-button variant="primary" @click="inicioRapido()"
              ><strong
              >INICIO DE CAJA RÁPIDO&nbsp;&nbsp;<i
                  class="bx bx-edit"
              ></i></strong
              ></b-button>
            </div>
            <div class="col d-grid gap-2">
              <router-link :to="{ name: 'inicioCaja' }">
                <b-button variant="primary"
                ><strong
                >IR A REGISTROS DE CAJA&nbsp;&nbsp;<i
                    class="bx bx-redo"
                ></i></strong
                ></b-button>
              </router-link>
            </div>
          </div>
          <template #modal-footer="{}"></template>
        </b-modal>

        <b-modal
            centered
            v-model="showModalL"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
            no-close-on-backdrop
            content-class="my-class"
            header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                      :animation-duration="2000"
                      :size="90"
                      color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

          <!-- Modal para Desactivar -->
          <b-modal
            centered
            id="modalAdelantos"
            ref="modalAdelantos"
            title="Listado de adelanto de pagos"
            title-class="text-black font-18"
            body-class="p-3"
            no-close-on-backdrop
        >
          <h4 align="center">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 70px">No.</th>
                    <th>Fecha</th>
                    <th>Pago</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in arrayAdelantos" v-bind:key="idx">
                    <td>{{ idx + 1 }}</td>
                    <td>
                      {{ item.fecha }}
                    </td>
                    <td class="text-sm-end">
                      {{ money(item.adelanto) }}
                    </td>
                  </tr>
                  <!-- <tr>
                    <td colspan="6" class="border-0 text-sm-end">
                      <strong>Total</strong>
                    </td>
                    <td class="border-0 text-sm-end">
                      <h4 class="m-0">{{ money(this.formPro.total) }}</h4>
                    </td>
                  </tr> -->
                </tbody>
              </table>
            </div>
          </h4>
          <template #modal-footer="{}">
            <b-button variant="secondary" @click="$bvModal.hide('modalAdelantos')"
            >Cerrar
            </b-button
            >
          </template>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
            centered
            id="modalAnular"
            ref="modalAnular"
            title="Anular venta"
            title-class="text-black font-18"
            body-class="p-3"
            no-close-on-backdrop
        >
          <h4 align="center">
            <!-- ¿Desea agregar la cantidad
            <strong>{{ money(formVenta.total) }}</strong> al saldo del cliente
            <strong>{{ formVenta.cliente }}</strong
            >?
            <br/>
            <switches
                type-bold="true"
                text-enabled="SI"
                text-disabled="NO"
                v-model="swAnular"
            ></switches> -->
            <b-input
                v-model="formVenta.descripcion"
                placeholder="Ingrese una observación"
            ></b-input>
          </h4>
          <template #modal-footer="{}">
            <b-button variant="secondary" @click="$bvModal.hide('modalAnular')"
            >Cerrar
            </b-button
            >
            <b-button variant="danger" @click="anularVenta">Anular</b-button>
          </template>
        </b-modal>
        <!-- Modal credito -->
        <b-modal
          centered
          @show="openModal('credito')"
          v-model="showModalA"
          id="modalCredito"
          ref="modalCredito"
          size="xl"
          title="Asignar crédito"
          title-class="text-black font-18"
          body-class="p-3"
          no-close-on-backdrop
        >
          <template #modal-header="{}">
            <h2>Asignar crédito</h2>
            <b-button variant="primary" @click="resetCredito">Limpiar</b-button>
          </template>
          <b-card>
            <div class="row">
              <div class="col">
                <b-card bg-variant="primary bg-soft">
                  <div class="row">
                    <div class="col">
                      <h5>Precio original</h5>
                      <h5>{{ money(formPro.total) }}</h5>
                    </div>
                    <div class="col">
                      <h5>Con adelanto</h5>
                      <h5>{{ money(formCredito.precioNuevo) }}</h5>
                    </div>
                  </div>
                  <br />
                  <label for="name">Adelanto</label>
                  <b-input
                    ref="inputCredito1"
                    v-model.trim="formCredito.adelanto"
                    @input="asignarAdelanto()"
                    type="number"
                    placeholder="Ingresar el monto de adelanto"
                    class="form-control"
                  />
                  <!-- <masked-input
                    v-model.trim="formCredito.adelanto"
                    :mask="mask_quetzal"
                    :guide="false"
                    :keep-char-positions="true"
                    :show-mask="true"
                    type="text"
                    @input="asignarAdelanto()"
                    placeholder="Ingresar el monto de adelanto"
                    class="form-control"
                  /> -->
                  <br />
                  <label for="name">Cantidad de pagos</label>
                  <b-input
                    type="number"
                    v-model="formCredito.cantidadPagos"
                    placeholder="Ingrese la cantidad de pagos"
                  />
                  <br />
                  <label for="name">Fecha inicio de pagos</label>
                  <datepicker
                  :bootstrap-styling="true"
                    v-model="formCredito.fechaInicio"
                    :first-day-of-week="1"
                    lang="es"
                  ></datepicker>
                  <br /><br />
                  <label for="name">Intervalo de días para pago</label>
                  <b-input
                    type="number"
                    v-model="formCredito.intervalo"
                    placeholder="Ingrese la cantidad de pagos"
                  />
                  <br />
                  <b-button @click="validarCredito">CÁLCULAR CRÉDITO</b-button>
                </b-card>
              </div>
              <div class="col" style="max-height: 485px; overflow-y: auto">
                <b-card bg-variant="primary bg-soft">
                  <h5>Distribución de pagos</h5>
                  <div v-for="(pago, index) in formCredito.pagos" :key="index">
                    <b-card no-body>
                      <h5 style="margin-top: 10px">
                        &nbsp;&nbsp;<span class="badge badge-pill bg-primary ms-1"
                          ><strong>{{ index + 1 }}</strong></span
                        >
                        {{
                          money(pago.monto_pago) + " | " + showDate(pago.fecha_pago)
                        }}
                      </h5>
                    </b-card>
                  </div>
                </b-card>
              </div>
            </div>
            <b-collapse v-model="formCredito.collapse1" visible class="mt-1">
              <b-tabs pills vertical nav-wrapper-class="col-sm-4">
                <!-- Efectivo -->
                <b-tab :disabled="checkSelect.efectivo">
                  <template v-slot:title>
                    <b-form-checkbox v-model="checkMoney.efectivo">
                      &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                        Efectivo</span
                      >&nbsp;
                      <i class="fas fa-money-bill"> </i>
                    </b-form-checkbox>
                  </template>

                  <b-card bg-variant="primary bg-soft">
                    <b-form-checkbox
                      v-model="checkMoney.efectivo"
                      @input="checkboxChange('efectivo')"
                      >&nbsp;&nbsp;Usar método de pago
                    </b-form-checkbox>
                    <br />
                    <b-form-group label="MONTO">
                      <masked-input
                        :disabled="!checkMoney.efectivo"
                        v-model.trim="$v.cantidad_efectivo.$model"
                        :mask="mask_quetzal"
                        :guide="false"
                        :keep-char-positions="true"
                        :show-mask="true"
                        type="text"
                        @input="sumarCantidades()"
                        placeholder="Ingresar el monto a pagar"
                        :class="{
                          'is-invalid': $v.cantidad_efectivo.$error,
                        }"
                        class="form-control"
                      />
                      <div
                        v-if="checkMoney.efectivo"
                        :class="{
                          'invalid-feedback': true,
                          'd-block':
                            $v.cantidad_efectivo.$invalid &&
                            !$v.cantidad_efectivo.$invalid.required,
                        }"
                      >
                        Debe ingresar el monto
                      </div>
                      <!-- <div
                            v-if="validarCantidades.efectivo <= 0"
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.validarCantidades.efectivo.$error &&
                                !$v.validarCantidades.efectivo.minValue,
                            }"
                          >
                            La cantidad debe ser mayor a cero
                          </div> -->
                    </b-form-group>
                  </b-card>
                </b-tab>
                <!-- Transferencia -->
                <b-tab :disabled="checkSelect.transferencia">
                  <template v-slot:title>
                    <b-form-checkbox v-model="checkMoney.transferencia">
                      &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                        Transferencia</span
                      >&nbsp;
                      <i class="bx bx-transfer-alt"> </i>
                    </b-form-checkbox>
                  </template>

                  <b-card bg-variant="primary bg-soft">
                    <b-form-checkbox
                      v-model="checkMoney.transferencia"
                      @input="checkboxChange('transferencia')"
                    >
                      &nbsp;&nbsp;Usar método de pago
                    </b-form-checkbox>
                    <br />
                    <div v-for="(item, index) in transferencia" v-bind:key="index">
                      <b-form-group
                        :label="'NÚMERO DE TRANSACCIÓN' + ' ' + (index + 1)"
                        class="has-float-label"
                      >
                        <b-input-group>
                          <b-form-input
                            :disabled="!checkMoney.transferencia"
                            :class="{
                              'is-invalid':
                                $v.transferencia.$each.$iter[index]
                                  .transaccion_transferencia.$error,
                            }"
                            v-model.trim="item.transaccion_transferencia"
                            placeholder="Ingresar en número de transacción"
                            @input="sumarCantidades()"
                          >
                          </b-form-input>
                          <b-input-group-append v-if="item.button">
                            <b-button
                              :disabled="!checkMoney.transferencia"
                              variant="primary"
                              @click="onButton('transferencia-plus')"
                              ><i :class="'bx bx-plus-medical'"
                            /></b-button>
                          </b-input-group-append>
                          <b-input-group-append v-if="!item.button">
                            <b-button
                              variant="primary"
                              @click="onButton('transferencia-minus', index)"
                              ><i :class="'bx bx-undo'"
                            /></b-button>
                          </b-input-group-append>
                        </b-input-group>
                        <div
                          v-if="checkMoney.transferencia"
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.transferencia.$each.$iter[index]
                                .transaccion_transferencia.$invalid &&
                              !$v.transferencia.$each.$iter[index]
                                .transaccion_transferencia.$invalid.required,
                          }"
                        >
                          Debe ingresar el número de transacción
                        </div>
                      </b-form-group>
                      <br />
                      <b-form-group label="MONTO">
                        <masked-input
                          :disabled="!checkMoney.transferencia"
                          v-model.trim="item.cantidad_transferencia"
                          :mask="mask_quetzal"
                          :guide="false"
                          :keep-char-positions="true"
                          :show-mask="true"
                          type="text"
                          @input="sumarCantidades()"
                          placeholder="Ingresar el monto a pagar"
                          :class="{
                            'is-invalid':
                              $v.transferencia.$each.$iter[index]
                                .cantidad_transferencia.$error,
                          }"
                          class="form-control"
                        />
                        <div
                          v-if="checkMoney.transferencia"
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.transferencia.$each.$iter[index]
                                .cantidad_transferencia.$invalid &&
                              !$v.transferencia.$each.$iter[index]
                                .cantidad_transferencia.$invalid.required,
                          }"
                        >
                          Debe ingresar el monto
                        </div>
                      </b-form-group>
                      <hr />
                    </div>
                  </b-card>
                </b-tab>
                <!-- Deposito -->
                <b-tab :disabled="checkSelect.deposito">
                  <template v-slot:title>
                    <b-form-checkbox v-model="checkMoney.deposito">
                      &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                        Deposito</span
                      >&nbsp;
                      <i class="bx bxs-downvote"> </i>
                    </b-form-checkbox>
                  </template>

                  <b-card bg-variant="primary bg-soft">
                    <b-form-checkbox
                      v-model="checkMoney.deposito"
                      @input="checkboxChange('deposito')"
                      >&nbsp;&nbsp;Usar método de pago
                    </b-form-checkbox>
                    <br />
                    <div v-for="(item, index) in deposito" v-bind:key="index">
                      <b-form-group
                        :label="'NÚMERO DE DEPOSITO' + ' ' + (index + 1)"
                        class="has-float-label"
                      >
                        <b-input-group>
                          <b-form-input
                            :disabled="!checkMoney.deposito"
                            :class="{
                              'is-invalid':
                                $v.deposito.$each.$iter[index].transaccion_deposito
                                  .$error,
                            }"
                            v-model.trim="item.transaccion_deposito"
                            placeholder="Ingresar en número deposito"
                            @input="sumarCantidades()"
                          >
                          </b-form-input>
                          <b-input-group-append v-if="item.button">
                            <b-button
                              :disabled="!checkMoney.deposito"
                              variant="primary"
                              @click="onButton('deposito-plus')"
                            >
                              <i :class="'bx bx-plus-medical'" />
                            </b-button>
                          </b-input-group-append>
                          <b-input-group-append v-if="!item.button">
                            <b-button
                              variant="primary"
                              @click="onButton('deposito-minus', index)"
                              ><i :class="'bx bx-undo'" />
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                        <div
                          v-if="checkMoney.deposito"
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.deposito.$each.$iter[index].transaccion_deposito
                                .$invalid &&
                              !$v.deposito.$each.$iter[index].transaccion_deposito
                                .$invalid.required,
                          }"
                        >
                          Debe ingresar el número de deposito
                        </div>
                      </b-form-group>
                      <br />
                      <b-form-group label="MONTO">
                        <masked-input
                          :disabled="!checkMoney.deposito"
                          v-model.trim="item.cantidad_deposito"
                          :mask="mask_quetzal"
                          :guide="false"
                          :keep-char-positions="true"
                          :show-mask="true"
                          type="text"
                          @input="sumarCantidades()"
                          placeholder="Ingresar el monto a pagar"
                          :class="{
                            'is-invalid':
                              $v.deposito.$each.$iter[index].cantidad_deposito
                                .$error,
                          }"
                          class="form-control"
                        />
                        <div
                          v-if="checkMoney.deposito"
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.deposito.$each.$iter[index].cantidad_deposito
                                .$invalid &&
                              !$v.deposito.$each.$iter[index].cantidad_deposito
                                .$invalid.required,
                          }"
                        >
                          Debe ingresar el monto
                        </div>
                      </b-form-group>
                      <hr />
                    </div>
                  </b-card>
                </b-tab>
                <!-- Cheque -->
                <b-tab :disabled="checkSelect.cheque">
                  <template v-slot:title>
                    <b-form-checkbox v-model="checkMoney.cheque">
                      &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                        Cheque</span
                      >&nbsp;
                      <i class="bx bx-dock-top"> </i>
                    </b-form-checkbox>
                  </template>

                  <b-card bg-variant="primary bg-soft">
                    <b-form-checkbox
                      v-model="checkMoney.cheque"
                      @input="checkboxChange('cheque')"
                      >&nbsp;&nbsp;Usar método de pago
                    </b-form-checkbox>
                    <br />
                    <div v-for="(item, index) in cheque" v-bind:key="index">
                      <b-form-group
                        :label="'NÚMERO DE CHEQUE' + ' ' + (index + 1)"
                        class="has-float-label"
                      >
                        <b-input-group>
                          <b-form-input
                            :disabled="!checkMoney.cheque"
                            :class="{
                              'is-invalid':
                                $v.cheque.$each.$iter[index].transaccion_cheque
                                  .$error,
                            }"
                            v-model.trim="item.transaccion_cheque"
                            placeholder="Ingresar en número dcheque"
                            @input="sumarCantidades()"
                          >
                          </b-form-input>
                          <b-input-group-append v-if="item.button">
                            <b-button
                              :disabled="!checkMoney.cheque"
                              variant="primary"
                              @click="onButton('cheque-plus')"
                              ><i :class="'bx bx-plus-medical'"
                            /></b-button>
                          </b-input-group-append>
                          <b-input-group-append v-if="!item.button">
                            <b-button
                              variant="primary"
                              @click="onButton('cheque-minus', index)"
                              ><i :class="'bx bx-undo'" />
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                        <div
                          v-if="checkMoney.cheque"
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.cheque.$each.$iter[index].transaccion_cheque
                                .$invalid &&
                              !$v.cheque.$each.$iter[index].transaccion_cheque
                                .$invalid.required,
                          }"
                        >
                          Debe ingresar el número dcheque
                        </div>
                      </b-form-group>
                      <br />
                      <b-form-group label="MONTO">
                        <masked-input
                          :disabled="!checkMoney.cheque"
                          v-model.trim="item.cantidad_cheque"
                          :mask="mask_quetzal"
                          :guide="false"
                          :keep-char-positions="true"
                          :show-mask="true"
                          type="text"
                          @input="sumarCantidades()"
                          placeholder="Ingresar el monto a pagar"
                          :class="{
                            'is-invalid':
                              $v.cheque.$each.$iter[index].cantidad_cheque.$error,
                          }"
                          class="form-control"
                        />
                        <div
                          v-if="checkMoney.cheque"
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.cheque.$each.$iter[index].cantidad_cheque
                                .$invalid &&
                              !$v.cheque.$each.$iter[index].cantidad_cheque.$invalid
                                .required,
                          }"
                        >
                          Debe ingresar el monto
                        </div>
                      </b-form-group>
                      <hr />
                    </div>
                  </b-card>
                </b-tab>
                <!-- Tarjeta -->
                <b-tab :disabled="checkSelect.tarjeta">
                  <template v-slot:title>
                    <b-form-checkbox v-model="checkMoney.tarjeta">
                      &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                        Tarjeta</span
                      >&nbsp;
                      <i class="far fa-credit-card"> </i>
                    </b-form-checkbox>
                  </template>

                  <b-card bg-variant="primary bg-soft">
                    <b-form-checkbox
                      v-model="checkMoney.tarjeta"
                      @input="checkboxChange('tarjeta')"
                      >&nbsp;&nbsp;Usar método de pago
                    </b-form-checkbox>
                    <br />
                    <div v-for="(item, index) in tarjeta" v-bind:key="index">
                      <b-form-group
                        :label="'NÚMERO DE TRANSACCIÓN TARJETA' + ' ' + (index + 1)"
                        class="has-float-label"
                      >
                        <b-input-group>
                          <b-form-input
                            :disabled="!checkMoney.tarjeta"
                            :class="{
                              'is-invalid':
                                $v.tarjeta.$each.$iter[index].transaccion_tarjeta
                                  .$error,
                            }"
                            v-model.trim="item.transaccion_tarjeta"
                            placeholder="Ingresar en número tarjeta"
                            @input="sumarCantidades()"
                          >
                          </b-form-input>
                          <b-input-group-append v-if="item.button">
                            <b-button
                              :disabled="!checkMoney.tarjeta"
                              variant="primary"
                              @click="onButton('tarjeta-plus')"
                              ><i :class="'bx bx-plus-medical'"
                            /></b-button>
                          </b-input-group-append>
                          <b-input-group-append v-if="!item.button">
                            <b-button
                              variant="primary"
                              @click="onButton('tarjeta-minus', index)"
                              ><i :class="'bx bx-undo'" />
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                        <div
                          v-if="checkMoney.tarjeta"
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.tarjeta.$each.$iter[index].transaccion_tarjeta
                                .$invalid &&
                              !$v.tarjeta.$each.$iter[index].transaccion_tarjeta
                                .$invalid.required,
                          }"
                        >
                          Debe ingresar el número de transacción de tarjeta
                        </div>
                      </b-form-group>
                      <br />
                      <b-form-group label="MONTO">
                        <masked-input
                          :disabled="!checkMoney.tarjeta"
                          v-model.trim="item.cantidad_tarjeta"
                          :mask="mask_quetzal"
                          :guide="false"
                          :keep-char-positions="true"
                          :show-mask="true"
                          type="text"
                          @input="sumarCantidades()"
                          placeholder="Ingresar el monto a pagar"
                          :class="{
                            'is-invalid':
                              $v.tarjeta.$each.$iter[index].cantidad_tarjeta.$error,
                          }"
                          class="form-control"
                        />
                        <div
                          v-if="checkMoney.tarjeta"
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.tarjeta.$each.$iter[index].cantidad_tarjeta
                                .$invalid &&
                              !$v.tarjeta.$each.$iter[index].cantidad_tarjeta
                                .$invalid.required,
                          }"
                        >
                          Debe ingresar el monto
                        </div>
                      </b-form-group>
                      <hr />
                    </div>
                  </b-card>
                </b-tab>
              </b-tabs>
              <br />
              <div class="row">
                <div class="col">
                  <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                    <h4 class="mt-0 mb-4 text-white">
                      <i class="bx bx-money me-3"></i> Total a pagar
                    </h4>
                    <h3 class="mt-0 mb-4 text-white" align="center">
                      {{
                        money(
                          parseFloat(converMaskToNumberxd(formCredito.adelanto)) > 0
                            ? parseFloat(converMaskToNumberxd(formCredito.adelanto))
                            : 0.0
                        )
                      }}
                    </h3>
                  </b-card>
                </div>
                <div class="col">
                  <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                    <h4 class="mt-0 mb-4 text-white">
                      <i class="bx bx-list-check me-3"></i> Restante de pago
                    </h4>
                    <h3 class="mt-0 mb-4 text-white" align="center">
                      {{
                        money(
                          parseFloat(converMaskToNumberxd(formCredito.adelanto)) > 0
                            ? parseFloat(
                                converMaskToNumberxd(formCredito.adelanto)
                              ) - montoFinal.cantidad
                            : 0.0
                        )
                      }}
                    </h3>
                  </b-card>
                </div>
                <div class="col">
                  <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                    <h4 class="mt-0 mb-4 text-white">
                      <i class="bx bx-detail me-3"></i> Cantidad pagando
                    </h4>
                    <h3 class="mt-0 mb-4 text-white" align="center">
                      {{
                        money(montoFinal.cantidad >= 0 ? montoFinal.cantidad : 0.0)
                      }}
                    </h3>
                  </b-card>
                </div>
              </div>
            </b-collapse>
          </b-card>

          <template #modal-footer="{}">
            <b-button variant="primary" @click="validarModalCredito"
              >Aceptar
            </b-button>
            <b-button variant="danger" @click="$bvModal.hide('modalCredito')"
              >Cerrar
            </b-button>
          </template>
        </b-modal>  
         <!-- Modal para CONTADO -->
         <b-modal
            centered
            id="modalContado"
            ref="modalContado"
            title="Pagar al contado"
            title-class="text-black font-18"
            body-class="p-3"
            no-close-on-backdrop
        >
          <h4 align="center">
            <!-- ¿Desea agregar la cantidad
            <strong>{{ money(formVenta.total) }}</strong> al saldo del cliente
            <strong>{{ formVenta.cliente }}</strong
            >?
            <br/>
            <switches
                type-bold="true"
                text-enabled="SI"
                text-disabled="NO"
                v-model="swAnular"
            ></switches> -->
            <!-- <b-input
                v-model="formVenta.descripcion"
                placeholder="Ingrese una observación"
            ></b-input> -->
          </h4>
          <template #modal-footer="{}">
            <b-button variant="secondary" @click="$bvModal.hide('modalContado')"
            >Cerrar
            </b-button
            >
            <b-button variant="danger" @click="savePagoCredito(false)">Pagar</b-button>
          </template>
        </b-modal>
        <!-- MODAL ADELANTO  -->
         <b-modal
            centered
            id="modalAdelanto"
            ref="modalAdelanto"
            title="Pagar Adelanto"
            title-class="text-black font-18"
            body-class="p-3"
            no-close-on-backdrop
        >
        <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Adelanto</label>
                  <input
                    id="name"
                    v-model="$v.adelanto.$model"
                    type="number"
                    class="form-control"
                    placeholder="Ingrese un nombre"
                    :class="{
                      'is-invalid': $v.adelanto.$error,
                    }"
                    @input="$v.adelanto.$touch()"
                  />
                  <div
                    v-if="
                      $v.adelanto.$error &&
                      !$v.adelanto.required
                    "
                    class="invalid-feedback"
                  >
                    El nombre es obligatorio.
                  </div>
               
                </div>
              </div>
              </div>  
          <template #modal-footer="{}">
            <b-button variant="secondary" @click="$bvModal.hide('modalAdelanto')"
            >Cerrar
            </b-button
            >
            <b-button variant="danger" @click="saveAdelanto()">Pagar</b-button>
          </template>
        </b-modal>
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Taller</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        @input="changePageSize()"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>
           

              <div class="col-sm-12 col-md-2">
                <div
                    id="tickets-table_length"
                    class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="searchType" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                          v-for="(search, index) in searchType"
                          :key="index"
                          @click="changeTypeSearch(search), activarBuscadorFechas(search, index);"
                      >{{ search.nombre }}
                      </b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-2 text-md-start" v-if="!bandera_fecha">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                        v-model="search"
                        type="search"
                        @input="onFiltered()"
                        placeholder="Buscar..."
                        class="form-control form-control-sm"
                    ></b-form-input>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-4" v-if="!bandera_fecha">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <label class="d-inline-flex align-items-center">
                      <router-link
                          :to="{
                          name: 'nuevoServicio',
                        }"
                      >
                        <button
                            v-b-modal.modalSave
                            type="button"
                            class="btn btn-success btn-rounded mb-2 me-2"
                        >
                          <b>NUEVA SERVICIO</b>&nbsp;&nbsp;<i
                            class="bx bxs-plus-circle"
                        ></i>
                        </button>
                      </router-link>
                    </label>
                  </label>
                </div>
              </div>
                <!-- Campo de fecha de inicio -->
                <div class="col-sm-12 col-md-3" v-if="bandera_fecha">
                  <!-- <label for="startDate" class="form-label">Fecha de inicio:</label> -->
                  <datepicker :bootstrap-styling="true"
                   @input="updateDisableDates()" placeholder="Fecha inicio" 
                   :language="es" :format="customFormatter" v-model="fecha_inicio"></datepicker>
                </div>

                <!-- Campo de fecha de fin -->
                <div class="col-sm-12 col-md-3" v-if="bandera_fecha">
                  <!-- <label for="endDate" class="form-label">Fecha de fin:</label> -->
                  <datepicker :bootstrap-styling="true" @input="changeTypeDates(fecha_inicio, fecha_fin)"  ref="myDatepicker" 
                  placeholder="Fecha fin" :disabledDates="disabledDates" :language="es" :format="customFormatter" v-model="fecha_fin"></datepicker>

                </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <!-- Desktop (>= md): tabla -->
              <div class="d-none d-lg-block">
              <vuetable
                  ref="vuetable"
                  class="table-divided order-with-arrow"
                  :css="css.table"
                  :api-url="apiBase"
                  :reactive-api-url="true"
                  :fields="fields"
                  :per-page="perPage"
                  :http-options="httpOptions"
                  :query-params="makeQueryParams"
                  :load-on-start="false"
                  pagination-path
                  @vuetable:pagination-data="onPaginationData"
              >
              <div slot="actions" slot-scope="props">
  <b-dropdown text="Opciones" variant="outline-primary" size="sm">
    <!-- Diagnosticar -->
    <router-link
      v-if="props.rowData.estado == 1 && props.rowData.estado_diagnostico != 'TERMINADO'"
      :to="{
        name: 'diagnosticoTaller',
        params: { id: props.rowData.id },
      }"
    >
      <b-dropdown-item-button variant="outline-primary"
      ><i class="bi bi-tools"></i>&nbsp;&nbsp;&nbsp;&nbsp;Diagnosticar</b-dropdown-item-button>
    </router-link>

    <!-- Ver más -->
    <router-link
      :to="{
        name: 'verTaller',
        params: {
          id: props.rowData.id,
          state: props.rowData.estado.toString(),
        },
      }"
    >
      <b-dropdown-item-button variant="outline-primary"
      ><i class="bi bi-eye"></i>&nbsp;&nbsp;&nbsp;&nbsp;Ver más</b-dropdown-item-button>
    </router-link>

    <!-- Imprimir Recibo -->
    <router-link
      v-if="props.rowData.estado && props.rowData.estado_diagnostico == 'DIAGNOSTICO' || props.rowData.estado_diagnostico == 'TERMINADO' || props.rowData.estado_diagnostico == 'REPARACIÓN'"
      :to="{
        name: 'reciboTaller',
        params: { id: props.rowData.id },
      }"
    >
      <b-dropdown-item-button variant="outline-primary"
      ><i class="bi bi-receipt"></i>&nbsp;&nbsp;&nbsp;&nbsp;Imprimir Recibo</b-dropdown-item-button>
    </router-link>

    <!-- Adelanto -->
    <b-dropdown-item-button
      v-if="props.rowData.estado_pagado == false && validateArqueo == true && props.rowData.estado_credito == null && props.rowData.estado_diagnostico !== 'TERMINADO'"
      v-b-modal.modalAdelanto
      @click="onActionClicked('aprobar-adelanto', props.rowData)"
    ><i class="bi bi-wallet-fill"></i>&nbsp;&nbsp;&nbsp;&nbsp;Adelanto</b-dropdown-item-button>

    <!-- Crédito -->
    <b-dropdown-item-button
      v-if="props.rowData.estado_pagado == false && validateArqueo == true && props.rowData.estado_credito == null && props.rowData.estado == true && props.rowData.estado_diagnostico == 'TERMINADO'"
      @click="onActionClicked('abonar-item', props.rowData)"
    ><i class="bi bi-credit-card"></i>&nbsp;&nbsp;&nbsp;&nbsp;Crédito</b-dropdown-item-button>

    <!-- Contado -->
    <b-dropdown-item-button
      v-if="props.rowData.estado_pagado == false && validateArqueo == true && props.rowData.estado_credito == null && props.rowData.estado == true && props.rowData.estado_diagnostico == 'TERMINADO'"
      v-b-modal.modalContado
      @click="onActionClicked('aprobar-contado', props.rowData)"
    ><i class="bi bi-cash"></i>&nbsp;&nbsp;&nbsp;&nbsp;Contado</b-dropdown-item-button>

    <!-- Anular Servicio -->
    <b-dropdown-item-button
      v-if="props.rowData.estado"
      v-b-modal.modalAnular
      @click="onActionClicked('aprobar-item', props.rowData)"
      variant="outline-danger"
    ><i class="bi bi-x-circle"></i>&nbsp;&nbsp;&nbsp;&nbsp;Anular Servicio</b-dropdown-item-button>

    <!-- Listado Adelantos -->
    <b-dropdown-item-button
      v-if="props.rowData.estado"
      v-b-modal.modalAdelantos
      @click="onActionClicked('adelantos', props.rowData)"
      variant="outline-danger"
    ><i class="bi bi-list-check"></i>&nbsp;&nbsp;&nbsp;&nbsp;Listado Adelantos</b-dropdown-item-button>
  </b-dropdown>
</div>


                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado == true">
                    <span class="badge bg-success ms-1"
                    ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                    ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>

                <div slot="estado_pago" slot-scope="props">
                  <h5 v-if="props.rowData.estado_credito == true && props.rowData.estado_pagado == true">
                    <span class="badge bg-primary ms-1"
                    ><strong>PAGADO</strong></span
                    >
                  </h5>
                  <h5  v-else-if="props.rowData.estado_credito == true && props.rowData.estado_pagado == false">
                    <span class="badge bg-warning ms-1"
                    ><strong>PENDIENTE</strong></span
                    >
                  </h5>
                  <h5  v-else-if="props.rowData.estado_credito == false">
                    <span class="badge bg-success ms-1"
                    ><strong>No Crédito</strong></span
                    >
                  </h5>
                </div>
                <div slot="empleado" slot-scope="props">
                  {{ props.rowData.user.empleado.persona.nombre_persona }}
                  {{ props.rowData.user.empleado.persona.apellido_persona }}
                </div>
                <div slot="cliente" slot-scope="props">
                 
                 <div> {{
                               props.rowData.vehiculo.cliente.persona.nombre_persona + '::' + props.rowData.vehiculo.modelo.auto.nombre_auto+ ' '
                               + props.rowData.vehiculo.modelo.nombre_modelo + ' ' + props.rowData.vehiculo.anio+ '::' + props.rowData.vehiculo.placa
                               
                  }}</div>
                 
                  <br/>
                </div>
                <div slot="fechac" slot-scope="props">
                  {{ showDate(props.rowData.fecha_entrada) }}
                </div>
                <div slot="fechach" slot-scope="props">
                  {{  showDate(props.rowData.fecha_entrega) }}
                </div>
                <div slot="total" slot-scope="props">
                  {{
                    props.rowData.total == 'null' ? '' : props.rowData.total =='' ? '' : props.rowData.total == null ? '':
                    money(
                      props.rowData.total
                    )
                  }}
                </div>
                <div slot="adelanto" slot-scope="props">
                  {{
                    money(sumarPagosTaller(props.rowData.adelantos_tallers))
                  }}
                </div>
                <div slot="estado_diagnostico_a" slot-scope="props">
                  <h5 v-if="props.rowData.estado_diagnostico == 'RECIBIDO' ">
                    <span class="badge bg-primary ms-1"
                    ><strong>RECIBIDO</strong></span
                    >
                  </h5>
                  <h5 v-if="props.rowData.estado_diagnostico == 'DIAGNOSTICO' ">
                    <span class="badge bg-warning ms-1"
                    ><strong>DIAGNOSTICO</strong></span
                    >
                  </h5>
                  <h5 v-if="props.rowData.estado_diagnostico == 'REPARACIÓN' ">
                    <span class="badge bg-danger ms-1"
                    ><strong>REPARACIÓN</strong></span
                    >
                  </h5>
                  <h5 v-if="props.rowData.estado_diagnostico == 'TERMINADO' ">
                    <span class="badge bg-info ms-1"
                    ><strong>TERMINADO</strong></span
                    >
                  </h5>
                  <h5 v-if="props.rowData.estado_diagnostico == 'ENTREGADO' ">
                    <span class="badge bg-success ms-1"
                    ><strong>ENTREGADO</strong></span
                    >
                  </h5>
                </div>
              </vuetable>
              </div>

              <!-- Móvil (< md): cards -->
              <ResponsiveCards :items="items">
                <template #card="{ item }">
                  <div class="rwd-card__head">
                    <span v-if="item.estado_diagnostico == 'RECIBIDO'" class="badge bg-primary">RECIBIDO</span>
                    <span v-else-if="item.estado_diagnostico == 'DIAGNOSTICO'" class="badge bg-warning">DIAGNOSTICO</span>
                    <span v-else-if="item.estado_diagnostico == 'REPARACIÓN'" class="badge bg-danger">REPARACIÓN</span>
                    <span v-else-if="item.estado_diagnostico == 'TERMINADO'" class="badge bg-info">TERMINADO</span>
                    <span v-else-if="item.estado_diagnostico == 'ENTREGADO'" class="badge bg-success">ENTREGADO</span>
                    <b-dropdown text="Opciones" variant="outline-primary" size="sm" right>
                      <router-link
                        v-if="item.estado == 1 && item.estado_diagnostico != 'TERMINADO'"
                        :to="{ name: 'diagnosticoTaller', params: { id: item.id } }">
                        <b-dropdown-item-button variant="outline-primary"><i class="bi bi-tools"></i> Diagnosticar</b-dropdown-item-button>
                      </router-link>
                      <router-link :to="{ name: 'verTaller', params: { id: item.id, state: item.estado.toString() } }">
                        <b-dropdown-item-button variant="outline-primary"><i class="bi bi-eye"></i> Ver más</b-dropdown-item-button>
                      </router-link>
                      <router-link
                        v-if="item.estado && item.estado_diagnostico == 'DIAGNOSTICO' || item.estado_diagnostico == 'TERMINADO' || item.estado_diagnostico == 'REPARACIÓN'"
                        :to="{ name: 'reciboTaller', params: { id: item.id } }">
                        <b-dropdown-item-button variant="outline-primary"><i class="bi bi-receipt"></i> Imprimir Recibo</b-dropdown-item-button>
                      </router-link>
                      <b-dropdown-item-button
                        v-if="item.estado_pagado == false && validateArqueo == true && item.estado_credito == null && item.estado_diagnostico !== 'TERMINADO'"
                        v-b-modal.modalAdelanto
                        @click="onActionClicked('aprobar-adelanto', item)"><i class="bi bi-wallet-fill"></i> Adelanto</b-dropdown-item-button>
                      <b-dropdown-item-button
                        v-if="item.estado_pagado == false && validateArqueo == true && item.estado_credito == null && item.estado == true && item.estado_diagnostico == 'TERMINADO'"
                        @click="onActionClicked('abonar-item', item)"><i class="bi bi-credit-card"></i> Crédito</b-dropdown-item-button>
                      <b-dropdown-item-button
                        v-if="item.estado_pagado == false && validateArqueo == true && item.estado_credito == null && item.estado == true && item.estado_diagnostico == 'TERMINADO'"
                        v-b-modal.modalContado
                        @click="onActionClicked('aprobar-contado', item)"><i class="bi bi-cash"></i> Contado</b-dropdown-item-button>
                      <b-dropdown-item-button
                        v-if="item.estado"
                        v-b-modal.modalAnular
                        @click="onActionClicked('aprobar-item', item)"
                        variant="outline-danger"><i class="bi bi-x-circle"></i> Anular Servicio</b-dropdown-item-button>
                      <b-dropdown-item-button
                        v-if="item.estado"
                        v-b-modal.modalAdelantos
                        @click="onActionClicked('adelantos', item)"
                        variant="outline-danger"><i class="bi bi-list-check"></i> Listado Adelantos</b-dropdown-item-button>
                    </b-dropdown>
                  </div>
                  <div class="rwd-card__title">Servicio {{ item.no_servicio }}</div>
                  <div class="rwd-card__sub">{{ item.vehiculo.cliente.persona.nombre_persona + '::' + item.vehiculo.modelo.auto.nombre_auto + ' ' + item.vehiculo.modelo.nombre_modelo + ' ' + item.vehiculo.anio + '::' + item.vehiculo.placa }}</div>
                  <div class="d-flex align-items-baseline justify-content-between mt-1">
                    <span class="rwd-card__value">{{ item.total == 'null' ? '' : item.total == '' ? '' : item.total == null ? '' : money(item.total) }}</span>
                    <span class="rwd-card__sub">Adelanto {{ money(sumarPagosTaller(item.adelantos_tallers)) }}</span>
                  </div>
                  <div class="rwd-card__meta">
                    <span>Ingreso {{ showDate(item.fecha_entrada) }}</span>
                    <span>Entrega {{ showDate(item.fecha_entrega) }}</span>
                  </div>
                </template>
              </ResponsiveCards>

              <div style="padding-top: 10px">
                <vuetable-pagination
                    ref="pagination"
                    :css="css.pagination"
                    @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
